import { useTranslation } from "react-i18next";
import { JuisciPrivacyPolicy } from "../../../partners/JuisciPrivacyPolicy";
import { SettingsSubHeader } from "../SettingsSubHeader";

/**
 * The privacy policy of Juisci, pushed from "Partner sharing" (Figma
 * O4.settings.privacy): the text alone, without the tabs of the privacy view
 * of the settings root, since the partners have their own view.
 */
export function JuisciPrivacyView(): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="flex h-full flex-col">
      <SettingsSubHeader title={t("Privacy policy")} />
      <div className="flex-1 overflow-y-auto scroll-fog-y px-5 pb-12">
        <JuisciPrivacyPolicy />
      </div>
    </div>
  );
}
